import { tinyMce } from "../vendor/tinyMce";

function toggleText() {
    const button = document.getElementById('rediger-forsiden');
    const adminPanel = document.querySelector('.admin-panel');

    if (!button || !adminPanel) {
        return;
    }

    adminPanel.classList.toggle('hidden');

    if (!adminPanel.classList.contains('hidden')) {
        tinyMce();
    }

    button.innerText = (button.innerText === "REDIGER FORSIDEN") ? "SKJUL ADMINISTRASJONSPANELET" : "REDIGER FORSIDEN";
}

function adminPanel() {
    const button = document.getElementById('rediger-forsiden');
    if(button) {
        button.addEventListener('click', toggleText);
    }
    $('a.js--show-versions').click(function() {
        document.querySelector('#show-versions').classList.toggle('hidden');
    });
}

export { adminPanel };
